import { getUserId } from '../utils/user';

const userId = getUserId();
export const RETURN_PATH = `/customer/returns/v1`;
export const OMS_PATH = '/oms/customer/order/v1';
// RETURN SERVICE PATHS
export const RETURN_SERVICE_ELIGIBILITY = `${RETURN_PATH}/checkEligibility`;
// ROS v2 eligibility endpoint. Path is TBD pending BE; using the agreed v2
// shape from the contract spike.
export const RETURN_SERVICE_ELIGIBILITY_V2 = `/customer/returns/v2/checkEligibility`;
// Return Methods endpoint, fronting the Return Options Service. Path is TBD
// pending BE; using the drafted path from the contract spike.
export const RETURN_METHODS_PATH = `/customer/returns/v2/returnMethods`;
// UPS grouping endpoint, fronting the shipping service's dry-run consolidation
// check. Tells us which drop-off lines ship together and the minimum number of
// boxes each group needs, before the return is created. Path is TBD pending BE;
// using the path the backend named on the contract spike.
export const UPS_GROUPING_PATH = `/customer/returns/v2/ups/grouping`;

export const PRINT_RETURN_SHIPPING_LABEL_PATH = `${RETURN_PATH}/user/${userId}/print/returnshippinglabel`;

export const POLICY_VALIDATOR = `${RETURN_PATH}/user/${userId}/ssrhrtvpolicyvalidator`;
export const REFUND_ESTIMATION = `${OMS_PATH}/refund/estimation`;
export const SS_RETURN_CREATE = `${RETURN_PATH}/user/${userId}/ssrreturncreate`;
export const FINALIZE_SORIS_RETURN = `${RETURN_PATH}/createsoris`;
export const VALIDATE_ADDRESS = `${RETURN_PATH}/validate/address`;
export const VALIDATE_ZIPCODE = `${RETURN_PATH}/validate/zipCode`;
export const ORDER_VERSION = `${RETURN_PATH}/order/orderinfo`;
export const APRISS_FINALIZE = `${RETURN_PATH}/finalize`;
// Naming to be finalized after BE completes work
export const SCHEDULED_PICKUPS = `${RETURN_PATH}/scheduled-pickups`;
